import FuzzySet from "fuzzyset";
export function nameMatch(name1, name2) {
    if (isComposedName(name1) || isComposedName(name2)) {
        return compareComposedNames(name1, name2);
    }
    const fs = FuzzySet([name1]);
    const score = fs.get(name2)?.[0]?.[0];
    if (!score) {
        return false;
    }
    return score > 0.5;
}
function isComposedName(name) {
    return name.includes(" ") || name.includes("-");
}
function compareComposedNames(name1, name2) {
    const parts1 = name1
        .replace("-", " ")
        .split(" ")
        .filter((part) => part.length > 0);
    const parts2 = name2
        .replace("-", " ")
        .split(" ")
        .filter((part) => part.length > 0);
    if (parts1.some((part) => parts2.some((p) => nameMatch(part, p)))) {
        return true;
    }
    return false;
}
//# sourceMappingURL=nameMatch.js.map